export * from './lib/tabs-panel';
